/**
 * Returns a formatted string based on the supplied dropdown option.
 *
 * @param {DropdownOptionBase} [dropdownOption]
 * @returns {string}
 */
export var getFormattedLabelFromDropdownOption = function (dropdownOption) {
    var _a;
    var label = (_a = dropdownOption === null || dropdownOption === void 0 ? void 0 : dropdownOption.label) !== null && _a !== void 0 ? _a : '';
    if (dropdownOption === null || dropdownOption === void 0 ? void 0 : dropdownOption.prefixLabel) {
        label = dropdownOption.prefixLabel + " - " + label;
    }
    return label;
};
//# sourceMappingURL=getFormattedLabelFromDropdownOption.js.map